var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeftFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2055 17.4831C13.0471 17.4831 12.8888 17.4247 12.7638 17.2997L7.33047 11.8664C6.44714 10.9831 6.44714 9.53307 7.33047 8.64974L12.7638 3.21641C13.0055 2.97474 13.4055 2.97474 13.6471 3.21641C13.8888 3.45807 13.8888 3.85807 13.6471 4.09974L8.2138 9.53307C7.8138 9.93307 7.8138 10.5831 8.2138 10.9831L13.6471 16.4164C13.8888 16.6581 13.8888 17.0581 13.6471 17.2997C13.5221 17.4164 13.3638 17.4831 13.2055 17.4831Z",
    fill: "#1B75BC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftFilled);
export default __webpack_public_path__ + "static/media/ChevronLeftFilled.d481ce9970c76e8600617248f9e3368f.svg";
export { ForwardRef as ReactComponent };